import { UserEnquiryLog, UserEnquiryLogInput } from "../models/UserEnquiryLog"
import client from './apolloClient';
import { CREATE_USER_ENQUIRY } from './mutation';




export const createNewEnquiry = async (newEnquiryLog: UserEnquiryLogInput): Promise<UserEnquiryLog> => {
    //  console.log("new newEnquiryLog = "+JSON.stringify(newEnquiryLog))
    try {
        const { data } = await client.mutate({
            mutation: CREATE_USER_ENQUIRY,
            variables: { newEnquiryLog },

        });
        return data?.createUserEnquiryLog;
    } catch (error) {
        console.log('Error fetching create new newEnquiryLog:', error);
        return { _id: "", name: "", phone: "", enquiryDate: '', from: '', to: '', bookingDate: '', returnRide: false };;
    }
}



